'use client'
import { useTranslations } from 'next-intl'
import { isNil } from 'lodash'

import type { LoanStatusForm as LoanStatusFormEnum } from '@/shared/models/loanModels'
import type { BadgeProps } from './Badge'
import Badge from './Badge'

export interface LoanStatusProps {
    status: LoanStatusFormEnum | undefined
}

const LoanStatus = ({ status }: LoanStatusProps) => {
    const t = useTranslations('root')

    const resolveBadgeType = (): BadgeProps['intent'] => {
        switch (status) {
            case 'BLOCKED':
            case 'PAST_DUE':
            case 'PAYMENT_FAILED':
                return 'negative'

            case 'REPAID':
                return 'positive'

            case 'REFUSED':
            case 'CANCELED':
            case 'PAYMENT_CANCELED':
                return 'default'

            case undefined:
            case 'ACCEPTED':
            case 'CREATED':
            case 'PAYMENT_ORDERED':
            case 'PAYMENT_RETRY_REQUESTED':
            case 'PENDING_ACCEPTED':
            case 'PENDING_REFUSED':
            case 'TO_REPAY':
            case 'UNSET':
            default:
                return 'information'
        }
    }

    return !isNil(status) ? (
        <Badge intent={resolveBadgeType()}>{t(`badges.${status.toLocaleLowerCase()}`)}</Badge>
    ) : null
}

export default LoanStatus
